import { render, staticRenderFns } from "./btn_table.vue?vue&type=template&id=23f6ac50&scoped=true"
import script from "./btn_table.vue?vue&type=script&lang=js"
export * from "./btn_table.vue?vue&type=script&lang=js"
import style0 from "./btn_table.vue?vue&type=style&index=0&id=23f6ac50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f6ac50",
  null
  
)

export default component.exports